module.exports = __webpack_public_path__ + "img/help_text_not_find@3x.09c65dd2.png";